<template>
    <div class="full-height pa-3" id="meeting_participant">
        
        <!-- LOADING -->
        <v-overlay :value="joining && !isLobby" opacity="1" color="background" :absolute="true">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>

        <!-- LOBBY -->
        <v-overlay :value="isLobby" color="header" opacity="1" class="text-center">
            <v-img :src="app.room.settings.header_logo" max-height="150" max-width="150" contain position="center" style="margin:auto;"></v-img>
            <div style="min-width:300px;max-width:90%;margin:auto;">
                <div class="mt-16 mb-8">
                    <div class="text-h5 text-md-h3">
                        <span>Hello{{ name.length > 0 ? `, ${name}` : '!' }}</span>
                    </div>
                </div>

                <v-text-field 
                    label="Please Enter Your Name for the Meeting"
                    x-large 
                    v-model="name"
                    class="mt-16"
                    :color="app.headerIsDark() ? 'white' : 'black'"
                    outlined
                >
                    <template v-slot:append>
                        <v-btn icon v-if="name.length > 0" @click="saveLobbyName"><v-icon>mdi-check-circle</v-icon></v-btn>
                    </template>
                </v-text-field>
                
            </div>
            <div v-if="true || say_hello" class="text-h6" :color="app.headerIsDark() ? 'white' : 'black'">
                Please wait. Your meeting will begin shortly.
            </div>
            <div v-else class="text-h6">&nbsp;</div>
        </v-overlay>

        <!-- EXIT SCREEN -->
        <v-overlay color="header" :value="meeting.leaving" opacity="1" class="text-center">
            <v-img v-if="app.room.settings.exit_image" :src="app.room.settings.exit_image" max-height="500" max-width="800" contain position="center"></v-img>
            <v-img v-else :src="app.room.settings.header_logo" max-height="150" max-width="90vw" contain position="center"></v-img>
            <!-- <div class="mt-6 text-center white--text primary rounded px-8 py-2 font-weight-light text-uppercase" style="display:inline-block;">{{ app.room.settings.exit_button_text ? app.room.settings.exit_button_text : 'Thanks for joining!' }}</div> -->
            <v-btn 
                class="mt-6 primary rounded font-weight-light elevation-0"
                @click="navToExitUrl()"
                large
            >
                {{ app.room.settings.exit_button_text ? app.room.settings.exit_button_text : 'Create Your Own Account Now' }}
            </v-btn>
            <div class="text-center mt-4">
                <v-btn text :color="app.headerIsDark() ? 'white' : 'black'"
                    @click="join()"
                >
                    <v-icon>mdi-arrow-left</v-icon>
                    Rejoin
                </v-btn>
                <v-btn  v-if="userIsLoggedIn()" 
                    :color="app.headerIsDark() ? 'white' : 'black'" 
                    text @click="$router.push({path: '/admin'})"
                >
                    <v-icon class="mr-1">mdi-cog</v-icon>
                    Admin
                </v-btn>
            </div>
        </v-overlay>        

        <!-- Login/Preview -->
        <v-overlay :absolute="true" color="background" :value="!isLobby && !joining && !meeting.leaving && !meeting.is_connected && (showJoinForm || showPreview)" opacity="1" ref="video_container">
            <v-row v-if="token && !error" >
                <v-col>
                    <v-card class="rounded-lg ma-2" elevation="0" width="400" max-width="100vw" style="margin:auto;" :loading="isLoadingVideoPlugin">
                        <v-responsive v-if="!isLivestreamViewer" :aspect-ratio="4/3" ref="preview_container">
                            <video 
                                v-if="meeting.local_peer && meeting.local_peer.videoTrack"
                                autoplay 
                                :muted="true" 
                                playsinline 
                                ref="preview_video"
                                width="100%"
                                class="mirror"
                                :key="preview_video_key"
                            ></video>
                            <v-skeleton-loader
                                v-else-if="meeting.local_peer && meeting.local_peer.roleName != 'qa'"
                                class="mx-auto rounded-lg"
                                max-width="100%"
                                max-height="350"
                                type="image, image"
                            ></v-skeleton-loader>
                            <v-overlay v-else :absolute="true">
                                <span v-if="meeting.local_peer && meeting.local_peer.roleName == 'qa'">Audio and Video are turned off for QAs</span>
                                <v-progress-circular v-else indeterminate size="48"></v-progress-circular>
                            </v-overlay>
                        </v-responsive>
                        
                        <v-card-text>
                            <!-- LOGIN FORM -->
                            <v-row v-if="show_admin_login" class="mt-2">
                                <v-col cols="12" v-if="show_admin_login">
                                    <v-text-field outlined label="Email" v-model="admin_email" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="show_admin_login">
                                    <v-text-field outlined label="Password" v-model="admin_password" hide-details="auto" type="password"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn @click="doLogin()" color="primary" x-large block :loading="is_logging_in">Login</v-btn>
                                </v-col>
                            </v-row>

                            <!-- LOGIN FORM -->
                            <v-row v-else class="mt-2">
                                <v-col cols="12" v-if="isLivestreamViewer || meeting.local_peer && meeting.local_peer.roleName">
                                    <v-text-field outlined label="Display Name" v-model="name" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="app.room.settings.show_email_field && (userIsGuest() || isLivestreamViewer)">
                                    <v-text-field 
                                        outlined 
                                        label="Email Address" 
                                        v-model="email_address" 
                                        hide-details="auto"
                                        :rules="app.room.settings.require_email_field ? [rules.email, rules.required] : [rules.email]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="app.room.settings.password && (userIsGuest() || isLivestreamViewer)">
                                    <v-text-field outlined label="Password" v-model="password" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="isLivestreamViewer || (meeting.local_peer && meeting.local_peer.roleName)">
                                    <v-btn v-if="isLivestreamViewer" @click="join()" color="primary" x-large block>Join Livestream</v-btn>
                                    <v-btn v-else @click="join()" color="primary" x-large block>Join as {{meeting.local_peer.roleName == 'waiting-room' ? 'Guest' : meeting.local_peer.roleName}}</v-btn>
                                </v-col>
                                <v-col cols="12" v-if="true || meeting.local_peer && meeting.local_peer.roleName" class="text-center">
                                    <template v-if="!userIsLoggedIn()">
                                        <v-btn v-if="login_url" text class="primary--text" :href="login_url">Admin Login</v-btn>
                                        <v-btn v-else-if="!show_admin_login" text class="primary--text" @click="show_admin_login = true">Admin Login</v-btn>
                                        <v-btn v-else text class="primary--text" @click="show_admin_login = false">Guest Login</v-btn>
                                    </template>
                                    <template v-if="userIsLoggedIn()">
                                        <v-btn v-if="outsetaToken()" text class="primary--text" :href="logout_url">Log Out</v-btn>
                                        <v-btn v-else text class="primary--text" @click="doLogout()">Log Out</v-btn>
                                    </template>
                                    <v-btn v-if="userIsLoggedIn()" text class="primary--text ml-3" href="/account/">Admin</v-btn>
                                    <v-btn v-if="!userIsLoggedIn() && registration_url != ''" text class="primary--text ml-3" :href="registration_url" target="_blank">Register</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="d-none d-md-flex" v-if="app.room.settings.profile_image || app.room.settings.profile_name">
                    <!-- <v-img :src="app.room.settings.profile_image" contain rounded-lg maxHeight="300" /> -->
                    <host-profile :settings="app.room.settings"></host-profile>
                </v-col>
            </v-row>

            <!-- ERROR -->
            <v-overlay v-else-if="error && error.code == '3001'" opacity="1" color="background" :absolute="true">
                <div class="text-center" style="width:400px;max-width:90vw;">
                    <div class="text-h4 mb-4">Camera and Microphone<br />Permissions are Missing</div>
                    <div>

                        <v-btn class="ma-2" v-if="micEnabled == null" outlined><v-icon class="mr-2">mdi-help-circle</v-icon> Microphone</v-btn>
                        <v-btn class="ma-2" v-if="micEnabled" color="success" outlined><v-icon class="mr-2">mdi-check-circle</v-icon> Microphone</v-btn>
                        <v-btn class="ma-2" v-else color="error" outlined><v-icon class="mr-2">mdi-close-circle</v-icon> Microphone</v-btn>
                        
                        <v-btn class="ma-2" v-if="cameraEnabled == null" outlined><v-icon class="mr-2">mdi-help-circle</v-icon> Camera</v-btn>
                        <v-btn class="ma-2" v-else-if="cameraEnabled" color="success" outlined><v-icon class="mr-2">mdi-check-circle</v-icon> Camera</v-btn>
                        <v-btn class="ma-2" v-else color="error" outlined><v-icon class="mr-2">mdi-close-circle</v-icon> Camera</v-btn>

                    </div>
                    <v-btn v-if="browser.browser.name != 'chrome'" x-large @click="promptForDevicePermission()" color="error">Try Again</v-btn>
                    <div v-else>
                        Look for the camera icon in the address bar and click on it to allow access to your camera and microphone.<br />Then reload the page.
                    </div>
                    <div v-if="profilePhone != ''" class="mt-4 font-weight-bold">To join the meeting by phone, call {{ profilePhone }}.</div>
                    
                    <v-text-field outlined label="Display Name" v-model="name" hide-details="auto" class="my-4"></v-text-field>
                    <v-btn @click="join()" color="primary" x-large block>Join as {{meeting.local_peer.roleName == 'waiting-room' ? 'Guest' : meeting.local_peer.roleName}}</v-btn>
                </div>
            </v-overlay>

            <template v-else-if="userIsLoggedIn() && !userCanJoinAs('host')">
                <div class="text-center">SELECT YOUR ROLE FOR THIS MEETING</div>
                <v-card class="rounded-lg ma-2" elevation="10" width="500" max-width="96vw">
                    <v-card-text>
                        <v-row grow>
                            <!-- <v-col cols="12">Join as:</v-col> -->
                            <v-col v-if="userIsRoomOwner()">
                                <v-btn @click="selectRole('host')" color="primary" block>Host</v-btn>
                            </v-col>
                            <v-col v-if="userCanJoinAs('coach')">
                                <v-btn @click="selectRole('coach')" color="primary" block>Coach</v-btn>
                            </v-col>
                            <v-col v-if="userCanJoinAs('qa')">
                                <v-btn @click="selectRole('qa')" color="primary" block>QA</v-btn>
                            </v-col>
                            <v-col v-if="userIsLoggedIn()">
                                <v-btn @click="selectRole('guest')" color="primary" block>Guest</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </template>
            <!-- <v-container class="text-center">
                <v-btn v-if="!show_admin_login && !userIsLoggedIn()" text class="primary--text" @click="show_admin_login = true">Login</v-btn>
                <v-btn v-else-if="!userIsLoggedIn()" text class="primary--text" @click="show_admin_login = false">Guest Login</v-btn>
                <v-btn v-if="userIsLoggedIn()" text class="primary--text" @click="doLogout()">Log Out</v-btn>
                <v-btn v-if="userIsLoggedIn()" text class="primary--text ml-3" @click="$router.push({path:'/admin'})">Admin</v-btn>

            </v-container> -->
        </v-overlay>


        <!-- SETTINGS DIALOG -->
        <v-dialog v-model="meeting.show_settings" maxWidth="600">
            <v-card>
                <v-card-title>Settings</v-card-title>
                <v-card-text>
                    <v-select
                        v-model="selected_camera"
                        label="Video"
                        :items="availableCameras()"
                        outlined
                        class="mt-6"
                    ></v-select>
                    <v-select
                        v-model="selected_microphone"
                        label="Microphone"
                        :items="availableMicrophones()"
                        outlined
                        class="mt-4"
                    ></v-select>
                    <v-select
                        v-if="userIsRoomOwner()"
                        v-model="app.room"
                        label="Room/Theme"
                        :items="app.rooms"
                        item-text="post_title"
                        :item-value="item => item"
                        outlined
                        class="mt-4"
                    ></v-select>
                    <v-switch
                        :label="meeting.blur_on ? 'Background Blur On' : 'Background Blur Off'"
                        v-model="meeting.blur_on"
                        @change="meeting.toggle_blur = true"
                    ></v-switch>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="meeting.show_settings=false" color="primary">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- VIDEO GRID -->
        <v-row v-if="meeting.is_connected && (!show_aux_track || isSharingScreen()) && !meeting.isCobrowsing() && !meeting.is_whiteboard_active">
            <v-col :cols="getValOrBlankCols(index)" v-for="(peer, index) in video_peers" 
                :key="peer.id"
                :class="'pa-2 ' + getValOrBlankColClass(index)"
            >
                <v-card :loading="loading_video_plugin && peer.isLocal" class="rounded-lg"
                    v-if="meeting.local_peer.roleName != 'waiting-room' || peer.isLocal"
                >
                    <video 
                        v-if="meeting.peer_video_enabled[peer.id]"
                        :aspect-ratio="16/9"
                        autoplay 
                        :muted="peer.isLocal" 
                        playsinline 
                        :ref="peer.id"
                        style="max-width:100%;width:100%;object-fit:cover;margin-bottom:-6px;"
                        :class="`rounded-lg ${grid[index] ? grid[index].class : ''} ${peer.isLocal ? ' mirror' : ''}`"
                    ></video>
                    <v-card v-else style="max-width:100%; margin-bottom:-6px;">
                        <v-responsive :aspect-ratio="16/9" :class="`rounded-lg ${grid[index] ? grid[index].class : ''}`">
                            <div class="fill-height" style="width: 100%; display: flex; align-items: center; justify-content: center;">
                                <span class="text-h4 font-weight-bold">{{ peer.name }}</span>
                            </div>
                        </v-responsive>
                    </v-card>
                    <!-- <v-overlay v-if="peer.roleName == 'host'" opacity="0" :absolute="true" style="justify-content:start;align-items:start;">
                        <v-img v-if="app.room && app.room.settings.header_logo != ''" :src="app.room.settings.header_logo" max-height="40" contain />
                    </v-overlay> -->
                    <v-overlay opacity="0" :absolute="true" style="justify-content:start;align-items:end;">
                        <v-chip class="mx-2 white--text mb-2" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                            {{peer.name}} 
                            <span v-if="meeting.local_peer.roleName != 'guest'" class="ml-1">({{peer.roleName.toUpperCase()}})</span>
                            <v-btn class="ml-1 white--text" icon x-small @click="['host', 'coach'].includes(meeting.local_peer.roleName) && meeting.enablePeerAudio(peer, !meeting.peer_audio_enabled[peer.id])">
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" color="red">mdi-microphone-off</v-icon>
                                <v-icon v-else>mdi-microphone</v-icon>
                            </v-btn>
                            <!-- VIDEO MENU -->
                            <meeting-participant-menu :peer="peer" v-if="meeting.permissions && meeting.permissions.changeRole"></meeting-participant-menu>
                        </v-chip>
                    </v-overlay>

                    <!-- ADMIT FROM WAITING ROOM BUTTON -->
                    <v-overlay :absolute="true" :value="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                        <v-btn v-if="meeting.local_peer.roleName == 'host'" color="primary" x-large @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                            Admit {{peer.name.toUpperCase()}}
                        </v-btn>
                    </v-overlay>
                </v-card>
            </v-col>

            <!-- WAITING ROOM HOST PLACEHOLDER -->
            <v-col 
                v-if="meeting.local_peer.roleName == 'waiting-room'" 
                :cols="grid[1].cols" 
                :class="'rounded-lg pa-2 pb-0 pl-0 '+ grid[1].col_class"
                style="justify-content:start;align-items:top;"
            >
                    <!-- <v-overlay :absolute="true">
                        <div class="text-h5 text--disabled">WAITING FOR HOST</div>
                    </v-overlay> -->
                    <host-profile :settings="app.room.settings" v-if="app.room.settings.profile_image || app.room.settings.profile_name"></host-profile>
                    <!-- <v-overlay v-else opacity="0" :absolute="true" :value="true">
                        <v-btn color="primary" x-large>
                            Waiting for Host
                        </v-btn>
                    </v-overlay> -->
                    <v-snackbar 
                        v-if="meeting.local_peer.roleName == 'waiting-room'"
                        v-model="show_waiting_for_host"
                        color="primary"
                        timeout="-1"
                        top
                    >
                        <div class="text-center">
                            Waiting for Host
                        </div>
                    </v-snackbar>
            </v-col>
        </v-row>
        

        <!-- SCREENSHARE LAYOUT -->
        <v-container v-if="show_aux_track && !isSharingScreen()" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="2">
                    <v-card v-for="peer in video_peers" :key="peer.id" class="rounded-lg mb-2" @mouseover="showNames=true" @mouseleave="showNames=false">
                        <video
                            :aspect-ratio="16/9"
                            autoplay 
                            :muted="peer.isLocal" 
                            playsinline 
                            :ref="peer.id"
                            style="width:100%;object-fit:cover;margin-bottom:-6px;"
                            :class="`rounded-lg video-quarter-height ${peer.isLocal ? ' mirror' : ''}`"
                        ></video>
                        <v-overlay :absolute="true" v-if="meeting.is_connected && showNames" opacity="0" style="justify-content:start;align-items:end;">
                            <v-chip class="ma-1 white--text" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                                {{peer.name}} 
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" class="ml-2" color="red">mdi-microphone-off</v-icon>
                            </v-chip>
                        </v-overlay>
                        <!-- ADMIT FROM WAITING ROOM BUTTON -->
                        <v-overlay :absolute="true" v-if="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                            <v-btn v-if="meeting.local_peer.roleName == 'host'" x-small color="primary" @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                                Admit {{peer.name.toUpperCase()}}
                            </v-btn>
                        </v-overlay>
                    </v-card>
                </v-col>
                <v-col cols="10">
                    <div>
                        <video 
                            :aspect-ratio="16/9"
                            autoplay 
                            playsinline 
                            ref="screenshare_video"
                            style="max-width:100%;width:100%;object-fit:contain;margin-bottom:-36px;"
                            :class="`rounded-lg video-full-height`"
                        ></video>

                        <!-- video player controls -->
                        <div v-if="show_video_playlist_item && meeting.video_playlist.length > 0" opacity="0" style="margin-top:-18px;">
                            <v-btn fab small elevation="2" class="ml-2" color="primary" @click="toggleVideoPlaylistItem()">
                                <v-icon>{{video_playlist_item_paused ? 'mdi-play' : 'mdi-pause'}}</v-icon>
                            </v-btn>
                            <v-btn fab small elevation="2" class="ml-1" @click="removeVideoPlaylistItem()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!-- LIVESTREAM LAYOUT -->
        <v-container v-if="meeting.isLivestreaming && meeting.local_peer && meeting.local_peer.roleName == 'livestream-viewer'" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="12">
                    <video 
                        :aspect-ratio="16/9"
                        autoplay 
                        playsinline 
                        ref="livestream_video"
                        style="max-width:100%;width:100%;object-fit:contain;margin-bottom:-36px;"
                        :class="`video-full-height`"
                    ></video>
                </v-col>
            </v-row>
        </v-container>


        <!-- COBROWSE LAYOUT -->
        <v-container v-if="meeting.is_connected && meeting.cobrowse_session && meeting.isCobrowsing()" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="2">
                    <v-card v-for="peer in video_peers" :key="peer.id" class="rounded-lg mb-2">
                        <video
                            :aspect-ratio="16/9"
                            autoplay 
                            :muted="peer.isLocal" 
                            playsinline 
                            :ref="peer.id"
                            style="width:100%;object-fit:cover;margin-bottom:-6px;"
                            :class="`rounded-lg video-sixth-height ${peer.isLocal ? ' mirror' : ''}`"
                        ></video>
                        <v-overlay :absolute="true" v-if="meeting.is_connected" opacity="0" style="justify-content:start;align-items:end;">
                            <v-chip class="ma-1 white--text" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                                {{peer.name}} 
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" class="ml-2" color="red">mdi-microphone-off</v-icon>
                            </v-chip>
                        </v-overlay>
                        <!-- ADMIT FROM WAITING ROOM BUTTON -->
                        <v-overlay :absolute="true" v-if="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                            <v-btn v-if="meeting.local_peer.roleName == 'host'" x-small color="primary" @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                                Admit {{peer.name.toUpperCase()}}
                            </v-btn>
                        </v-overlay>
                    </v-card>
                </v-col>
                <v-col cols="10">
                    <iframe
                        class="video-full-height rounded-lg"
                        style="width:100%;margin-bottom:-36px;"
                        :src="meeting.local_peer.roleName == 'host' ? meeting.cobrowse_session.leader_link+'?name='+meeting.local_peer.name : meeting.cobrowse_session.follower_link+'?name='+meeting.local_peer.name"
                        allow="autoplay *; display-capture *; geolocation *;"
                    >
                    </iframe>
                    
                </v-col>
            </v-row>
            
        </v-container>
        
        
        <!-- WHITEBOARD LAYOUT -->
        <v-container v-if="meeting.is_connected && meeting.is_whiteboard_active" fluid class="mt-0 full-height pa-0">
            <v-row dense>
                <v-col cols="2">
                    <v-card v-for="peer in video_peers" :key="peer.id" class="rounded-lg mb-2">
                        <video
                            :aspect-ratio="16/9"
                            autoplay 
                            :muted="peer.isLocal" 
                            playsinline 
                            :ref="peer.id"
                            style="width:100%;object-fit:cover;margin-bottom:-6px;"
                            :class="`rounded-lg video-sixth-height ${peer.isLocal ? ' mirror' : ''}`"
                        ></video>
                        <v-overlay :absolute="true" v-if="meeting.is_connected" opacity="0" style="justify-content:start;align-items:end;">
                            <v-chip class="ma-1 white--text" :color="`${peer.roleName == 'coach' ? 'orange' : 'grey'} darken-4`" small>
                                {{peer.name}} 
                                <v-icon v-if="!meeting.peer_audio_enabled[peer.id]" class="ml-2" color="red">mdi-microphone-off</v-icon>
                            </v-chip>
                        </v-overlay>
                        <!-- ADMIT FROM WAITING ROOM BUTTON -->
                        <v-overlay :absolute="true" v-if="peer.roleName == 'waiting-room' && ['host','coach'].includes(meeting.local_peer.roleName)">
                            <v-btn v-if="meeting.local_peer.roleName == 'host'" x-small color="primary" @click="meeting.hmsActions.changeRole(peer.id, 'guest', true);">
                                Admit {{peer.name.toUpperCase()}}
                            </v-btn>
                        </v-overlay>
                    </v-card>
                </v-col>
                <v-col cols="10">
                    <div class="video-full-height rounded-lg" style="width:100%;margin-bottom:-36px;" id="wt-container"></div>
                </v-col>
            </v-row>
        </v-container>


        <!-- BM: SNACKBAR ALERTS -->
        <v-snackbar 
            :centered="!!app.snackbar.settings.centered" 
            :color="app.snackbar.settings.color" 
            v-model="app.snackbar.settings.show" 
            :top="!!app.snackbar.settings.top"
            :right="!!app.snackbar.settings.right" 
            :timeout="app.snackbar.timeout"
            style="cursor:pointer;"
        >
            <span @click="handleSnackbarClick(app.snackbar.settings.click)">
                {{app.snackbar.settings.message}}
            </span>
            <template v-slot:action="{ attrs }">
                <v-btn
                    icon
                    v-bind="attrs"
                    @click="app.snackbar.settings.show = false"
                >
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </template>
        </v-snackbar>

        <v-overlay :value="meeting.is_connected && meeting.local_peer && ['coach','qa'].includes(meeting.local_peer.roleName) && meeting.isCobrowsing()" :absolute="true" opacity="0"></v-overlay>

    </div>
</template>

<script>
import axios from 'axios'
import { useAppStore } from '../stores/app'
import { useUserStore } from '../stores/user'
import { useMeetingStore } from '../stores/meeting'
import Hls from 'hls.js'
import Sniffr from 'sniffr'

import {
  HMSReactiveStore,
  selectIsLocalAudioEnabled,
  selectIsLocalVideoEnabled,
  selectIsLocalScreenShared,
  selectPeers,
  selectIsConnectedToRoom,
  selectLocalPeerRoleName,
  selectLocalPeer,
  selectIsInPreview,
  selectDevices,
  selectLocalMediaSettings,
  selectIsLocalVideoPluginPresent,
  selectIsPeerAudioEnabled,
  selectIsPeerVideoEnabled,
  selectHMSMessages,
  selectPermissions,
  selectPeerMetadata,
  selectScreenShareByPeerID,
  selectRecordingState,
  selectHLSState,
  selectRTMPState,
  selectAuxiliaryTracksByPeerID,
  selectVideoPlaylist,
  selectAudioPlaylist,
  selectRoomStarted,
  selectSessionId,
} from "@100mslive/hms-video-store"
import { setVirtualBackground, HMSVirtualBackgroundPlugin } from '@100mslive/hms-virtual-background'
import MeetingParticipantMenu from './MeetingParticipantMenu.vue'
import HostProfile from './HostProfile.vue'
import { supabase } from '../lib/supabaseClient'

// Initialize HMS Store
const hmsManager = new HMSReactiveStore()
hmsManager.triggerOnSubscribe()
const hmsStore = hmsManager.getStore()
const hmsActions = hmsManager.getActions()
const hmsNotifications = hmsManager.getNotifications()

export default {
    name: 'MeetingParticipant',
    components: {
        MeetingParticipantMenu,
        HostProfile
    },
    created: function() {
        console.log("meeting participant", this.$route.params)
        this.app = useAppStore()
        this.user = useUserStore()
        this.meeting = useMeetingStore()

        this.name = window.localStorage.getItem('meeting_display_name') ?? ''
        this.email_address = window.localStorage.getItem('meeting_email_address') ?? ''
        if(localStorage.getItem('uniqid') == null)
            localStorage.setItem('uniqid', String(Math.random())) 
    },
    data() {
        return {
            app: null,
            user: null,
            meeting: null,
            name: "",
            password: "",
            email_address: "",
            show_admin_login: false,
            admin_email: "",
            admin_password: "",
            token: null,
            peers: [],
            videoRefs: [],
            isMuted: false,
            videoMuted: false,
            screenshare_peer_id: null,
            show_aux_track: false,
            aux_track: null,
            preview_track: null,
            selected_camera: null,
            selected_microphone: null,
            selected_devices: null,
            preview_video_key: 'preview_video_key',
            loading_video_plugin: false,
            grid: [
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
                { class:'video-half-height', cols:4 },
            ],
            leaving: false,
            joining: false,
            is_logging_in: false,
            show_cobrowse: false,
            selected_room: null,
            presense_channel: null,
            presense: null,
            lobby_presence: null,
            lobbies: [],
            show_waiting_for_host: true,
            video_playlist_item_paused: false,
            error: null,
            browser: {browser:{name:''}},
            micEnabled: null,
            cameraEnabled: null,
            session_is_logged: false,
            say_hello: false,
            showNames: false,
            renderPeersInterval: null,
            rules: {
                required: value => {
                    return !!value || 'Required.'
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return value == '' || pattern.test(value) || 'Invalid e-mail.'
                },
            },
            // rooms: []
        }
    },
    mounted: async function() {
        if(this.isLobby) {
            // create presence channel for this lobby
            this.updateLobbyPresence()
            return
        } else {
            //connect to lobbies, if any
            console.log("lobbies", this.user.userdata.lobbies)
            if(this.user?.userdata?.lobbies?.length > 0)
                this.listenToLobbies(this.user.userdata.lobbies)
        }

        this.getBrowser()
        await this.user.fetchUser()
        if(!this.userIsLoggedIn()) {
            console.log("not logged in, get token")
            let role = this.isLivestreamViewer ? 'livestream-viewer' : 'guest'
            await this.getToken(role)
            if(!this.isLivestreamViewer && !['record', 'record-guest'].includes(this.$route.params.role))
                this.preview()
        } else if(this.userCanJoinAs('host')) {
            await this.getToken('host')
            this.preview()
        }

        this.createSubscriptions()

        this.setUpGrid()
        let g = this
        window.onresize = function() {
            g.setUpGrid()
        }
        this.renderPeersInterval = setInterval(() => {
            g.renderPeers()
        }, 5000)

        this.meeting.hmsActions = hmsActions
        this.meeting.hmsStore = hmsStore


        // window.onunload = this.leave()

        this.handleNotifications()

        // (function(s,u,r,f,l,y){s[f]=s[f]||{init:function(){s[f].q=arguments}};
        // l=u.createElement(r);y=u.getElementsByTagName(r)[0];l.async=1;
        // l.src='https://surfly.com/surfly.js';y.parentNode.insertBefore(l,y);})
        // (window,document,'script','Surfly');

        // var settings = {
        // // Surfly session options can be set here, or at the Company/Plan levels.
        // widget_key: 'b6013a7e576e41549e709b3041f23928',
        // private_session: false, // to make sure only logged in agents can join the calls
        // password_required: false,
        // url: 'https://dialerup.com'
        // };

        // Surfly.init(settings, function(initResult) {
        //     if (initResult.success) {
        //         // API calls can now be made!
        //         if (!Surfly.isInsideSession) {
        //             Surfly.button();
        //         }
        //     }
        //     else{
        //         console.log("Surfly was unable to initialize properly.")
        //     }
        // });
    },
    beforeDestroy() {
        // this.leave()
    },
    computed: {
        // isMuted: function() {
        //     return hmsStore.getState(selectIsLocalAudioEnabled)
        // }
        // isConnected: function() {
        //     return this.is_connected
        // },
        isLoadingVideoPlugin() {
            return !this.isLivestreamViewer && 
                (this.loading_video_plugin || 
                !this.meeting.local_peer || 
                !this.meeting.local_peer.videoTrack);
        },
        login_url: function() {
            return this.app?.site?.domain_settings?.settings?.domain?.meta?.login_url[0] ?? false
        },
        logout_url: function() {
            let logout_url = this.app?.site?.domain_settings?.settings?.domain?.meta?.logout_url[0] ?? '/wp-logout.php'
            if(logout_url == '/#o-logout-link')
                logout_url = window.location.origin + window.location.pathname + '#o-logout-link'
            return logout_url
        },
        registration_url: function() {
            // if(this.app?.site?.domain_settings?.settings?.domain?.meta?.hide_registration_url[0] == '1')
            //     return ''

            let url = this.app?.site?.domain_settings?.settings?.domain?.meta?.registration_url[0]
            // url += "?registration_domain="+window.location.host
            // url += "&registration_title="
            // url += this.app?.site?.domain_settings?.settings?.domain?.meta?.registration_title[0] ?? "Create Your Account"
            // console.log("url", url)
            return url
        },
        profilePhone: function() {
            return this.app.room.settings.profile_phone_number ?? ""
        },  
        showJoinForm: function() {
            return !this.meeting.is_connected && this.peers.length == 0
        },
        showPreview: function() {
            return !this.showJoinForm && this.peers.length == 1 && this.peers[0].isLocal && this.peers[0].roleName != 'record-guest'
        },
        video_peers: function() {
            return this.peers.filter(peer => {
                //hide recording beam
                if(['record', 'record-guest', 'qa'].includes(peer.roleName))
                    return false

                if(peer.isLocal)
                    return true

                // if they're in the waiting room, only return their own video
                if(this.meeting?.local_peer?.roleName == 'waiting-room' && !peer.isLocal)
                    return false

                // if this isn't the recording beam and this user is not a guest, then show the video feed
                if(this.meeting?.local_peer?.roleName !== 'guest' && this.meeting?.local_peer?.roleName !== 'waiting-room')
                    return true
                
                //is a guest
                if(['guest', 'host'].includes(peer.roleName))
                    return true

                return false
            })
            // return this.peers.filter(peer => this.meeting.peer_video_enabled[peer.id])
        },
        isLivestreamViewer: function() {
            return !this.userIsLoggedIn() && this.app.room.settings?.room_type == 'livestream'
        },
        isLobby: function() {
            return this.app.room.settings?.lobby == 1
        }
    },
    methods: {
        createSubscriptions: function() {
            if(!['record', 'record-guest'].includes(this.$route.params.role)) {
                hmsStore.subscribe(this.inPreview, selectIsInPreview)
                hmsStore.subscribe(selected_devices => this.selected_devices = selected_devices, selectLocalMediaSettings)
                hmsStore.subscribe(video_enabled => this.meeting.local_video_enabled = video_enabled, selectIsLocalVideoEnabled)
                hmsStore.subscribe(audio_enabled => this.meeting.local_audio_enabled = audio_enabled, selectIsLocalAudioEnabled)
                hmsStore.subscribe(messages => this.meeting.messages = messages, selectHMSMessages)
                hmsStore.subscribe(permissions => this.meeting.permissions = permissions, selectPermissions)
                // hmsStore.subscribe(recording_state => {
                //     this.meeting.recording_state = recording_state
                //     if(recording_state.browser.error) {
                //         this.meeting.recording_starting = false
                //         this.app.showError('Error starting recording')
                //     } else if(recording_state.browser.running) {
                //         this.meeting.recording_starting = false
                //     }
                // }, selectRecordingState)
            }
            hmsStore.subscribe(this.renderPeers, selectPeers)
            hmsStore.subscribe(connected => this.meeting.is_connected = connected, selectIsConnectedToRoom)
            hmsStore.subscribe(peer => this.meeting.local_peer = peer, selectLocalPeer)
            hmsStore.subscribe(screen_shared => this.meeting.is_local_screen_shared = screen_shared, selectIsLocalScreenShared)
            hmsStore.subscribe(livestream_state => this.meeting.livestream_state = livestream_state, selectRTMPState);
            hmsStore.subscribe(video_playlist => this.meeting.video_playlist = video_playlist, selectVideoPlaylist.list);
            hmsStore.subscribe(audio_playlist => this.meeting.audio_playlist = audio_playlist, selectAudioPlaylist.list);
            hmsStore.subscribe(room_started => this.meeting.room_started = room_started, selectRoomStarted)
            hmsStore.subscribe(session_id => this.meeting.session_id = session_id, selectSessionId)
            
        },
        handleNotifications: function() {
            let unsubscribe = hmsNotifications.onNotification(async (notification) => {
                console.log('NOTIFICATION (participant):', notification.type, notification);
                switch(notification.type) {
                    case 'NEW_MESSAGE':
                        this.app.showNotification(`${notification.data.senderName}: ${notification.data.message}`, 5, 'chat')
                        //add to new message count if chat is not shown
                        if(this.meeting.participants_chat_switch != 'chat')
                            this.meeting.new_message_count++
                        break
                    case 'PEER_JOINED':
                        if(notification.data.roleName.indexOf('record') > -1 && !['record', 'record-guest'].includes(this.meeting.local_peer.roleName)) {
                            // this.app.showNotification('This meeting is being recorded.')
                            this.meeting.is_recording = true
                            this.meeting.recording_starting = false
                            break
                        }
                        if(this.meeting.local_peer.roleName == 'waiting-room')
                            break
                        if(this.meeting.local_peer.roleName == 'guest' && !['host', 'guest'].includes(notification.data.roleName))
                            break
                        if(notification.data.roleName == 'waiting-room') {
                            this.app.showNotification(`${notification.data.name} is in the WAITING ROOM`, 5, 'participants')
                            this.app.playNotification('waiting_room')
                        } else if(notification.data.roleName != 'qa') {
                            this.app.showNotification(`${notification.data.name} (${notification.data.roleName.toUpperCase()}) has joined the meeting.`, 5, 'participants')
                            this.app.playNotification(notification.type)
                            this.updateMetadata({["peer-joined-"+notification.data.name]:notification.data.customerUserId})
                        } else {
                            this.updateMetadata({["peer-joined-"+notification.data.name]:notification.data.customerUserId})
                        }
                        break
                    case 'PEER_LEFT':
                        if(notification.data.roleName.indexOf('record') > -1 && !['record', 'record-guest'].includes(this.meeting.local_peer.roleName)) {
                            // this.app.showNotification('Recording has stopped.')
                            this.meeting.is_recording = false
                            this.meeting.recording_starting = false
                            break
                        }    
                        // stop recording if the recording peer is the only one left
                        if(this.peers.length == 1 && ['record', 'record-guest'].includes(this.meeting.local_peer.roleName)) {
                            this.meeting.stopRecording()
                            break
                        }
                        if(['waiting-room', 'record', 'record-guest'].includes(this.meeting.local_peer.roleName))
                            break
                        if(this.meeting.local_peer.roleName == 'guest' && !['host', 'guest'].includes(notification.data.roleName))
                            break
                        this.app.showNotification(`${notification.data.name} has left the meeting.`, 5, 'participants')
                        this.app.playNotification(notification.type)
                        break
                    case 'CHANGE_TRACK_STATE_REQUEST':
                        if(notification.data.enabled)
                            this.app.showNotification(`${notification.data.requestedBy.name} (${notification.data.requestedBy.roleName}) wants you to unmute your ${notification.data.track.type}.`, -1)
                        if(!notification.data.enabled)
                            this.app.showNotification(`${notification.data.requestedBy.name} (${notification.data.requestedBy.roleName}) muted your ${notification.data.track.type}.`, -1)
                        break
                    case 'METADATA_UPDATED':
                        const metadata = JSON.parse(notification.data.metadata)
                        this.meeting.isScreenSharingEnabled = metadata.isScreenSharingEnabled ? metadata.isScreenSharingEnabled[this.meeting.local_peer.id] : false
                        this.meeting.cobrowse_session = metadata.cobrowse_session
                        this.meeting.whiteboard_code = metadata.whiteboard_code
                        if(metadata.whiteboard_code && metadata.whiteboard_code != "") {
                            console.log("whiteboard_code:", metadata.whiteboard_code)
                            this.meeting.is_whiteboard_active = true
                            this.meeting.activateWhiteboard()
                        } else {
                            this.meeting.is_whiteboard_active = false
                        }
                        if(metadata.room) {
                            this.app.room = metadata.room
                        }
                        break
                    case 'ROLE_UPDATED':
                        if(notification.data.isLocal) {
                            switch(notification.data.roleName) {
                                case "guest":
                                case "coach":
                                case "host":
                                    this.app.showNotification(`You are now a ${notification.data.roleName.toUpperCase()}`)
                                    this.app.playNotification(notification.type)
                                    break;
                                case "waiting-room":
                                    this.app.showNotification(`You are now in the WAITING ROOM`)
                                    break;
                            }
                            
                        } else {
                            this.updateMetadata({["role-update-"+notification.data.name]:notification.data.customerUserId})
                        }
                        break
                    case 'TRACK_UNMUTED':
                        this.renderPeers()
                        break;
                    case 'ROOM_ENDED':
                    case 'REMOVED_FROM_ROOM':
                        // this.meeting.presence_channel.untrack()
                        this.meeting.leaving = true
                        break
                    case 'ERROR':
                        this.checkDevicePermissions()
                        this.error = notification.data
                        break
                    case 'STOP_RECORDING':
                        this.meeting.stopRecording()
                        break;
                }
            });
        },
		outsetaToken: function() {
			return localStorage.getItem('Outseta.nocode.accessToken') ?? false
		},
        checkDevicePermissions: function() {
            if(this.userIsRecordingBeam())
                return
            this.checkMicEnabled()
            this.checkCameraEnabled()
            if(!this.micEnabled || !this.cameraEnabled)
                this.promptForDevicePermission()
        },
        checkMicEnabled: async function() {
            let status = await navigator.permissions.query({ name: 'microphone' })
            this.micEnabled = status.state == 'granted'
        },
        checkCameraEnabled: async function() {
            let status = await navigator.permissions.query({ name: 'camera' })
            this.cameraEnabled = status.state == 'granted'
        },
        getBrowser: function() {
            var s = new Sniffr();
            this.browser = s.sniff(navigator.userAgent)
        },
        promptForDevicePermission: function() {
            let videoExists = false;
            let audioExists = false;
            let g = this

            navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                devices.forEach(function(device) {
                    if (device.kind === 'videoinput') {
                        videoExists = true;
                    }
                    if (device.kind === 'audioinput') {
                        audioExists = true;
                    }
                });

                let constraints = {};
                if (videoExists) {
                    constraints.video = true;
                }
                if (audioExists) {
                    constraints.audio = true;
                }

                if (!videoExists && !audioExists) {
                    console.log("No video or audio devices found.");
                    return;
                }

                return navigator.mediaDevices.getUserMedia(constraints);
            })
            .then(function(stream) {
                if (stream) {
                    // Handle the stream
                    g.error = null;
                }
            })
            .catch(function(error) {
                console.log("error:", error);
                let g = this
                if (error.name === 'NotAllowedError') {
                    // Prompt the user for permission again
                    navigator.mediaDevices.getUserMedia(constraints)
                        .then(function(stream) {
                            // Handle the stream
                            g.error = null;
                        })
                        .catch(function(error) {
                            console.log("error:", error);
                        });
                }
            });
        },
        toggleVideoPlaylistItem: function() {
            if(this.video_playlist_item_paused) {
                this.meeting.hmsActions.videoPlaylist.play('myvideo')
                this.video_playlist_item_paused = false
            } else {
                this.meeting.hmsActions.videoPlaylist.pause()
                this.video_playlist_item_paused = true
            }
        },
        removeVideoPlaylistItem: function() {
            if(this.meeting.video_playlist.length > 0) {
                this.meeting.hmsActions.videoPlaylist.stop()
                this.meeting.hmsActions.videoPlaylist.clearList()
            } else if(this.meeting.audio_playlist.length > 0) {
                this.meeting.hmsActions.audioPlaylist.stop()
                this.meeting.hmsActions.audioPlaylist.clearList()
            }
        },  
        // updateParticpantMetadata: function() {
        //     const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
        //     await this.meeting.hmsActions.changeMetadata(newMetadata)
        //     console.log("metadata init update", newMetadata)
        // },
        navToExitUrl: function() {
            if(this.app.room.settings.exit_button_url && this.app.room.settings.exit_button_url != '')
                window.location.href = this.app.room.settings.exit_button_url
            else
                window.location.href = this.app?.site?.domain_settings?.settings?.domain?.meta?.registration_url[0]
        },
        getValOrBlankColClass: function(index) {

            return this?.grid[index]?.col_class ?? ''
        },
        getValOrBlankCols: function(index) {
            return this?.grid[index]?.cols ?? ''
        },
        updateMetadata: async function(obj) {
            //obj is designed to be a unique bit of data to add to force the update to broadcast
            // This is designed for when a guest joins after a meeting has started along with co-browsing, etc
            // Without modifying the data somehow, it's not going to broadcast (at least that's what I'm seeing)

            if(this.meeting.local_peer.roleName != 'host')
				return
            setTimeout(async () => {
                const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
                const newMetadata = { ...metadata, random: Math.random(), ...obj }  // ...obj is a random update to force the notification
                await this.meeting.hmsActions.changeMetadata(newMetadata)
                console.log("metadata init update", newMetadata)
            }, 2000)
        },
        userCanJoinAs: function(role) {
            if(!this.user.userdata.roles || !this.user.userdata.room_access)
                return false
            if(this.user.userdata.roles && this.user.userdata.roles.includes(['administrator', 'editor']) )
                return true
            if(this.userIsRoomOwner())
                return true

            let key = `_${this.app.room.ID}_${role}`
            let can_join = false
            this.user.userdata.room_access.forEach(access => {
                if(access.indexOf(key) > -1)
                    can_join = true
            })
            return can_join
        },
        userIsLoggedIn: function() {
            return this.user?.userdata?.data?.ID
        },
        userIsRoomOwner: function() {
            return this.app.room.post_author == this.user?.userdata?.data?.ID
        },
        userIsGuest: function() {
            return this.meeting?.local_peer?.roleName == 'guest' || this.meeting?.local_peer?.roleName == 'waiting-room'
        },
        userIsRecordingBeam: function() {
            return this.meeting?.local_peer?.roleName == 'record' || this.meeting?.local_peer?.roleName == 'record-guest' || !['record', 'record-guest', undefined].includes(this.$route.params.role)
        },
        doLogout: async function() {
            this.app.logOut()
            // console.log(response)
        },
        // doLoginOld: function() {
        //     this.is_logging_in = true
        //     this.show_login_error = false

        //     var data = new FormData();
        //     data.append("email", this.admin_email);
        //     data.append("password", this.admin_password);

        //     axios.post('/wp-admin/admin-ajax.php?action=dialer_login', data)
        //         .then(response => {
        //             this.is_logging_in = false
        //             if(response.data.login.ID > 0) {
        //                 window.location.reload()
        //             } else {
        //                 this.is_logging_in = false
        //                 // this.show_login_error = true
        //                 this.app.showError("Login Failed")
        //             }
        //         })
        //         .catch(error => {
        //             this.is_logging_in = false
        //         })
        // },
        doLogin: function() {
            this.is_logging_in = true
            this.show_login_error = false

            this.app.post('meeting/login', { user_login: this.admin_email, user_password: this.admin_password })
                .then(response => {
                    this.is_logging_in = false
                    if(response.data.ID > 0) {
                        window.location.reload()
                    } else {
                        this.is_logging_in = false
                        // this.show_login_error = true
                        this.app.showError("Login Failed")
                    }
                })
                .catch(error => {
                    this.is_logging_in = false
                    this.app.showError('Login failed')
                })
        },
        getPreviewVideoSkeletonHeight: function() {

            return '350px'
        },
        getVideoClass: function() {
            let count = this.peers.filter(peer => peer.videoTrack).length
            switch(count) {
                case 1:
                case 2:
                    return 'videos-a'
                default:
                    return 'videos-default'
            }
        },
        getPeerVideoStatus: function(peerId) {
            return hmsStore.getState(selectIsPeerVideoEnabled(peerId));
        },
        getPeerAudioStatus: function(peerId) {
            return hmsStore.getState(selectIsPeerAudioEnabled(peerId));
        },
        getToken: function(role = 'guest') {
            console.log("getting token")
            var g = this
            var identity = this.user.userdata.data?.display_name ?? "customer"
            var url = "meeting/token"

            var data = {
                room_id: this.app.room_id
            }

            if(['coach', 'qa', 'record', 'record-guest'].includes(this.$route.params.role))
                data.role = this.$route.params.role
            else if(role)
                data.role = role

            return g.app.post(url, data).then(async response => {
                g.token = response.data.token
                console.log("got token?", response.data)
                if(['record', 'record-guest'].includes(this.$route.params.role)) {
                    console.log("============== record, join the meeting now!")

                    // //prevent multiple recording peers from joining
                    // let recording_peers = 0
                    // this.meeting.peers.forEach(peer => {
                    //     console.log("check peers for rec:", peer)
                    //     if(peer.roleName.indexOf('record') > -1)
                    //         recording_peers++
                    //     console.log("recording_peers1", recording_peers)
                    // })
                    // console.log("recording_peers2", recording_peers)
                    // if(recording_peers >= 1)
                    //     return

                    await g.join()
                } else {
                    // g.preview()
                    return
                }
            })
        },
        availableCameras: function() {
            let devices = hmsStore.getState(selectDevices);
            let selected_devices = hmsStore.getState(selectLocalMediaSettings)
            this.selected_camera = selected_devices.videoInputDeviceId
            
            let cameras = []
            devices.videoInput.forEach(camera => {
                cameras.push({text:camera.label, value:camera.deviceId})
            })
            return cameras
        },
        availableMicrophones: function() {
            let devices = hmsStore.getState(selectDevices);
            let selected_devices = hmsStore.getState(selectLocalMediaSettings)
            this.selected_microphone = selected_devices.audioInputDeviceId
            
            let microphones = []
            devices.audioInput.forEach(microphone => {
                microphones.push({text:microphone.label, value:microphone.deviceId})
            })
            return microphones
        },
        inPreview: function(isInPreview) {
            this.is_in_preview = isInPreview 
            if(isInPreview)
                this.$nextTick(() => {
                    if(this.meeting.local_peer && this.meeting.local_peer.videoTrack && this.$refs.preview_video) {
                        this.toggleVideo(true)
                        hmsActions.attachVideo(this.meeting.local_peer.videoTrack, this.$refs.preview_video)
                    }
                })
                
        },
        selectRole: async function(role) {
            await this.getToken(role)
            this.preview()
        },
        preview: async function() {
            const config = {
                userName: this.name,
                authToken: this.token, // client-side token generated from your token service
                settings: {
                    // initial states
                    isAudioMuted: false,
                    isVideoMuted: false
                },
                metaData: JSON.stringify({ city: 'Winterfell', knowledge: 'nothing' }),
                rememberDeviceSelection: true, // remember manual device change
                captureNetworkQualityInPreview: false // whether to measure network score in preview
            };
            await hmsActions.preview(config);
        },
        onConnection: function(isConnected) {
            this.meeting.is_connected = isConnected
        },
        join: async function() {
            if(!this?.user?.userdata?.ID > 0 && this.app.room.settings.show_email_field && this.rules.email(this.email_address) !== true) {
                this.app.showError('A valid Email Address is required')
                return
            }

            this.meeting.leaving = false
            window.localStorage.setItem('meeting_display_name', this.name)
            window.localStorage.setItem('meeting_email_address', this.email_address)

            // if(role != 'guest') {
            //     console.log("get token for", role)
            //     await this.getToken(role)
            //     console.log("got token for 2", role)
            // }

            if(this.app.room.settings.password && this.userIsGuest()) {
                let g = this
                this.app.post('meeting/check-password', { room_id: this.app.room.ID, password: this.password })
                .then(async response => {
                    g.joining = true
                    await hmsActions.join({
                        userName: this.name,
                        authToken: this.token,
                        rememberDeviceSelection: true,
                    })
                    g.joining = false
                })
                .catch(error => {
                    this.app.showError('Login failed')
                    this.lists.loading = false
                })
            } else {
                this.joining = true
                await hmsActions.join({
                    userName: this.name,
                    authToken: this.token
                })

                // console.log("joined")
                this.joining = false
            }

            // Temp disable to see if it helps with recording issues
            this.updatePresence()
            
            // const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
            // console.log("meeting metadata", metadata)
            // this.meeting.isScreenSharingEnabled = metadata.isScreenSharingEnabled ? metadata.isScreenSharingEnabled[this.meeting.local_peer.id] : false
            // this.meeting.cobrowse_session = metadata.cobrowse_session ?? {}
        },
        updatePresence: function() {
            // turned this off for a while to see if recordings were affected
            // 1/11 - turning this back on now (with next deployment) recordings appear to be working
            // return
            let roleName = this.meeting?.local_peer?.roleName
            if(!roleName || roleName.indexOf('viewer') > -1)
                return

            let g = this
            this.meeting.presence_channel = supabase.channel('presenceChannel')
            this.meeting.presence_channel
                .on('presence', { event: 'sync' }, () => {
                    g.presence = this.meeting.presence_channel.presenceState()
                    console.log("presence state:", g.presence)
                })
                .subscribe(async (status) => {
                    if (status === 'SUBSCRIBED') {
                        const presenceTrackStatus = await g.meeting.presence_channel.track({
                            user_id: g.user?.userdata?.ID,
                            room_id: this.app.room.ID,
                            role: g.meeting?.local_peer?.roleName,
                            // user_name: g.user?.userdata?.data?.display_name ?? this.name,
                            user_name: this.name,
                            online_at: new Date().toISOString(),
                        })
                        console.log("presenceTrackStatus", presenceTrackStatus)
                    }
                })
        },
        listenToLobbies: function(IDs) {
            console.log("listen to lobbies", IDs)
            // this.listenToLobby(1803)
            // return
            // let num = 0
            IDs.forEach(ID => {
                this.listenToLobby(ID)
                // num++
            })
        },
        listenToLobby(ID) {
            // const supabase = useSupabase();
            console.log("listenToLobby", ID)
            // Check if already listening to this channel to avoid duplicate subscriptions
            // if (this.meeting.lobby_presence_channels[`lobby-${ID}`]) {
            //     console.log(`Already subscribed to lobby-${ID}`);
            //     return;
            // }

            // Subscribe to a new channel
            this.meeting.lobby_presence_channel[ID] = supabase.channel('lobby-'+ID)
                .on('presence', { event: 'sync' }, (eventData) => {
                    // Handle the presence event
                    console.log(`Presence event on lobby:`, eventData, this.meeting.lobby_presence_channel[ID].presenceState());
                    this.meeting.refresh_lobby = Math.random()
                    // Update your Vue component state or Pinia store as needed
                })
                // WIP - needs refinement so we don't show a blank name
                // .on('presence', { event: 'join' }, (eventData) => {
                //     console.log(`Presence JOIN event on lobby:`, this.meeting.lobby_presence_channel[ID].presenceState().newPresences)                    
                //     let presence = this.meeting.lobby_presence_channel[ID].presenceState()
                //     console.log("join presence", presence)
                //     if(Array.isArray(presence.newPresences)) {
                //         this.meeting.lobby_presence_channel[ID].presenceState().newPresences.forEach(presence => {
                //             this.app.showNotification(presence.guest_name+' is in the lobby')
                //         })
                //     }
                // })
                .subscribe(async (status) => {
                if (status === 'SUBSCRIBED') {
                    console.log("subscribed to lobby", ID)
                }
            })


            // Store the channel reference
            // this.meeting.lobby_presence_channels[`lobby-${ID}`] = channel;
            // this.meeting.lobby_presence_channel = channel
            // console.log("done creating lobby", ID, this.meeting.lobby_presence_channel)
        },

        // Method in your component or store to update the lobbies state
        updateLobbies: function() {
            // Update the lobbies state here in a way that ensures reactivity
            // For example, if lobbies is a number:
            this.meeting.lobbies++;

            // If lobbies is an object or array, you might need to replace it entirely or use Vue.set for modifications
        },

        updateLobbyPresence: function() {
            console.log("updateLobbyPresence")
            let g = this
            this.meeting.lobby_presence_channel = supabase.channel('lobby-'+this.app.room.ID)
            .on('presence', { event: 'sync' }, (eventData) => {
                g.lobby_presence = this.meeting.lobby_presence_channel.presenceState()
                console.log("presence state:", g.lobby_presence, eventData)
                let channels = this.meeting.lobby_presence_channel.presenceState()
                Object.keys(channels).forEach(channel => {
                    channels[channel].forEach(item => {
                        console.log("item", item)
                        if(item.action == 'admit' && item.guest && item.guest.uniqid == this.uniqId()) {
                            let path = ""
                            if(Object.keys(this.$route.query)?.length > 0)
                                path = this.$route.fullPath.substring(1)
                            console.log("Path:", path)
                            window.location.href = item.url+path
                        }
                    })
                })
            })
            .subscribe(async (status) => {
                console.log('subscribe status:', status)
                if (status === 'SUBSCRIBED') {
                    const lobbyPresenceTrackStatus = await g.meeting.lobby_presence_channel.track({
                        guest_name: this.name,
                        room_id: this.app.room.ID,
                        uniqid: this.uniqId(),
                        online_at: new Date().toISOString(),
                    })
                    console.log("lobbyPresenceTrackStatus", lobbyPresenceTrackStatus)
                }
            })
        },
        uniqId() {
            return localStorage.getItem('uniqid')
        },
        updateLobbyGuestName: async function() {
            const presenceTrackStatus = await this.meeting.lobby_presence_channel.track({
                guest_name: this.name,
                room_id: this.app.room.ID,
                uniqid: this.uniqId(),
            })
        },
        getPeersVideoStatus: function() {
            // this.peers.forEach(peer => console.log("Peer:", peer.name, hmsStore.getState(selectIsPeerVideoEnabled(peer.id))))
            this.renderPeers()
        },
        handlePeerVideoStatusChange: function(peerId, newV, oldV) {},
        renderPeers: function(peers) {
            this.setUpGrid()
            if(hmsStore.getState(selectIsInPreview)) {
                return
            }
            
            if(peers && peers.length > 0) {
                this.peers = peers
                this.meeting.peers = peers
            }
            

            // listen for mute/unmute of audio/video
            let g = this
            this.peers.forEach(peer => {
                hmsStore.subscribe(enabled => this.$set(this.meeting.peer_audio_enabled, peer.id, enabled), selectIsPeerAudioEnabled(peer.id))
                hmsStore.subscribe(function(enabled) {
                    g.$set(g.meeting.peer_video_enabled, peer.id, enabled)
                    // g.setUpGrid()
                }, selectIsPeerVideoEnabled(peer.id))
            })

            // this.video_peers = this.peers.filter(peer => {
            //     return hmsStore.getState(selectIsPeerVideoEnabled(peer.id))
            // })

            //after dom updates, attach the video tracks
            this.$nextTick(() => {
                this.peers.forEach(peer => {
                    if(peer.videoTrack != undefined) {
                        if(this.$refs[peer.id] && this.$refs[peer.id].length) {
                            hmsActions.attachVideo(peer.videoTrack, this.$refs[peer.id][0])
                        } else if(!this.meeting.leaving && peer.videoTrack && this.$refs[peer.id]) {
                            console.log("the peer", peer)
                            hmsActions.attachVideo(peer.videoTrack, this.$refs[peer.id])
                        }
                    }
                    // We don't want to hear the waiting room participants
                    if(peer.roleName == "waiting-room")
                        hmsActions.setVolume(0, peer.audioTrack);
                    else
                        hmsActions.setVolume(100, peer.audioTrack);
                })
            })
            //screenshare
            this.show_aux_track = false
            this.aux_track = null
            this.peers.forEach(peer => {
                if(peer.auxiliaryTracks.length > 0) {

                    const tracks = this.meeting.hmsStore.getState(selectAuxiliaryTracksByPeerID(peer.id))
                    tracks.forEach(track => {
                        if(track.type == 'video'){
                            this.show_aux_track = true
                            this.show_video_playlist_item = true
                            this.aux_track = peer.auxiliaryTracks[1] ?? peer.auxiliaryTracks[0]
                            this.$nextTick((peer) => {
                                hmsActions.attachVideo(this.aux_track, this.$refs.screenshare_video)
                            })
                        }
                    })


                    // this.show_aux_track = true
                    // this.aux_track = peer.auxiliaryTracks[1] ?? peer.auxiliaryTracks[0]
                    // this.$nextTick((peer) => {
                    //     hmsActions.attachVideo(this.aux_track, this.$refs.screenshare_video)
                    // })
                }
            })  
        },
        // toggleAudio: function(on) {
        //     const audioEnabled = !hmsStore.getState(selectIsLocalAudioEnabled);
        //     if(audioEnabled != on)
        //         hmsActions.setLocalAudioEnabled(on);
        //     this.isMuted = on
        // },
        toggleVideo: function(on) {
            if(on) {
                hmsActions.setLocalVideoEnabled(on)
                this.videoMuted = on
            } else {
                const videoEnabled = !hmsStore.getState(selectIsLocalVideoEnabled)
                hmsActions.setLocalVideoEnabled(videoEnabled)
                this.videoMuted = !videoEnabled
            }
            this.$nextTick(() => {
                this.renderPeers()
            })
        },
        showVideoTile: function(peer) {
            let localRoleName = hmsStore.getState(selectLocalPeerRoleName)
            return true
        },
        toggleScreen: function () {
            // let is_sharing = hmsStore.getState(selectIsLocalScreenShared)
            hmsActions.setScreenShareEnabled(!this.isSharingScreen());
        },  
        isSharingScreen: function() {
            return hmsStore.getState(selectIsLocalScreenShared)
        },
        testBtn: function() {
            let is_sharing = hmsStore.getState(selectIsLocalScreenShared)
        },
        // getScreenShare: function() {
        //     let screenshare = hmsStore.getState(selectScreenShareByPeerID(this.screenshare_peer_id))
        //     hmsActions.attachVideo(screenshare, this.$refs.screenshare_video)
        // },
        virtualBackgroundIsSupported: function( ) {
            this.virtual_background = new HMSVirtualBackgroundPlugin()
            const pluginSupport = hmsActions.validateVideoPluginSupport(this.virtual_background);
            if (pluginSupport.isSupported) {
                return true
            } else {
                const err = pluginSupport.errMsg;
                console.error(err);
                return false
            }
        },
        blurOn: async function(preview = false) {
            if(!this.virtualBackgroundIsSupported())
                return

            // const img = document.createElement("img");
            // img.src = "https://images.unsplash.com/photo-1496681859237-6039cd585c4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80";
            // const virtualBackground = new HMSVirtualBackgroundPlugin(img)
            const virtualBackground = new HMSVirtualBackgroundPlugin('blur')

            //is it already on?
            const isVirtualBackgroundEnabled = hmsStore.getState(
                selectIsLocalVideoPluginPresent(virtualBackground.getName())
            );

            if(isVirtualBackgroundEnabled)
                return this.blurOff()


            this.loading_video_plugin = true
            await virtualBackground.init()
            this.loading_video_plugin = false
            
            const pluginFrameRate = 15;
            await hmsActions.addPluginToVideoTrack(virtualBackground, pluginFrameRate);
            this.meeting.blur_on = true
            this.$nextTick(() => {
                let is_in_preview = hmsStore.getState(selectIsInPreview)
                let ref = is_in_preview ? 'preview_video' : this.meeting.local_peer.id
                if(is_in_preview) {
                    if(this.meeting?.local_peer?.videoTrack)
                        hmsActions.attachVideo(this.meeting.local_peer.videoTrack, this.$refs[ref])
                } else {
                    this.renderPeers()
                }
            })
        },
        blurOff: async function(preview = false) {
            const virtualBackground = new HMSVirtualBackgroundPlugin('none')
            await hmsActions.removePluginFromVideoTrack(virtualBackground);
            this.meeting.blur_on = false
            let is_in_preview = hmsStore.getState(selectIsInPreview)
            let ref = is_in_preview ? 'preview_video' : this.meeting.local_peer.id
            this.$nextTick(() => {
                // if(is_in_preview)
                //     hmsActions.attachVideo(this.meeting.local_peer.videoTrack, this.$refs[ref])
                // else
                //     this.renderPeers()
                if(is_in_preview) {
                    if(this.meeting?.local_peer?.videoTrack)
                        hmsActions.attachVideo(this.meeting.local_peer.videoTrack, this.$refs[ref])
                } else {
                    this.renderPeers()
                }
            })
        },
        setUpGrid: function() {
            let count = this.video_peers.length
            let window_ratio = window.innerWidth/window.innerHeight
            let window_is = 'normal'

            // console.log("window_ratio", window_ratio)

            //creating a spot for a host placeholder in the waiting room
            if(this.meeting?.local_peer?.roleName == 'waiting-room')
                count = 2
            
            if(window_ratio < 0.4)
                window_is = 'extra-narrow'
            else if(window_ratio < 0.75)
                window_is = 'narrow'
            else if(window_ratio < 0.9)
                window_is = 'portrait'
            else if(window_ratio > 3)
                window_is = 'extra-wide' 
            else if(window_ratio > 2)
                window_is = 'wide'
            else if(window_ratio > 1.75)
                window_is = 'landscape'
                

            var grid = [];

            if(count == 1) {
                // grid[0] = { class:'video-full-height', cols:12 }
                if(['extra-narrow', 'narrow', 'portrait'].includes(window_is))
                    grid[0] = { class:'video-half-height', cols:12, col_class:'translate-half' }
                else if(['extra-wide', 'wide'].includes(window_is))
                    grid[0] = { class:'video-full-height', cols:4, col_class:'offset-4' }
                else if(['landscape'].includes(window_is))
                    grid[0] = { class:'video-full-height', cols:6, col_class:'offset-3' }
                else
                    grid[0] = { class:'video-two-thirds-height', cols:6, col_class:'offset-3 translate-third' }
            }

            else if(count == 2) {
                if(['extra-narrow', 'narrow', 'portrait'].includes(window_is)) {
                    grid = Array.from({length: 2}, (_, index) => {return { class:'video-half-height', cols:12}})
                } else if(['wide'].includes(window_is)) {
                    grid = Array.from({length: 2}, (_, index) => {return { class:'video-full-height', cols:6}})
                } else if(['extra-wide'].includes(window_is)) {
                    grid[0] = { class:'video-full-height', cols:4, col_class:'offset-2'}
                    grid[1] = { class:'video-full-height', cols:4 }
                } else if(['landscape'].includes(window_is)) {
                    grid = Array.from({length: 2}, (_, index) => {return { class:'video-full-height', cols:6}})
                } else {
                    grid = Array.from({length: 2}, (_, index) => {return { class:'video-two-thirds-height', cols:6, col_class:'translate-third'}})
                }
            }

            else if(count == 3) {
                if(['wide', 'extra-wide'].includes(window_is))
                    grid = Array.from({length: 3}, (_, index) => {return { class:'video-full-height', cols:4 }})
                else if(['extra-narrow'].includes(window_is))
                    grid = Array.from({length: 3}, (_, index) => {return { class:'video-third-height', cols:12 }})
                else if(['narrow', 'portrait'].includes(window_is)) {
                    grid = Array.from({length: 2}, (_, index) => {return { class:'video-half-height', cols:6 }})
                    grid[2] = { class:'video-half-height', cols:12 }
                } else if(['landscape'].includes(window_is)) {
                    grid = Array.from({length: 3}, (_, index) => {return { class:'video-full-height', cols:4 }})
                } else {
                    grid = Array.from({length: 2}, (_, index) => {return { class:'video-half-height', cols:6 }})
                    grid[2] = { class:'video-half-height', cols:6, col_class:'offset-3' }
                }
            }

            else if(count == 4) {
                if(window_is == 'extra-narrow')
                    grid = Array.from({length: 4}, (_, index) => {return { class:'video-quarter-height', cols:12 }})
                else if(['wide', 'extra-wide'].includes(window_is))
                    grid = Array.from({length: 4}, (_, index) => {return { class:'video-full-height', cols:3 }})
                else
                    grid = Array.from({length: 4}, (_, index) => {return { class:'video-half-height', cols:6 }})
            }
            
            else if(count == 5) {
                if(window_is == 'portrait')
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:6 }})
                else if(window_is == 'narrow')
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:6 }})
                else if(window_is == 'extra-narrow')
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fifth-height', cols:12 }})
                else if(window_is == 'wide')
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-half-height', cols:4 }})
                else if(window_is == 'extra-wide')
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-full-height', cols:2 }})
                else    
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-half-height', cols:4 }})
            }
            

            else if(count == 6) {
                if(['portrait','narrow'].includes(window_is))
                    grid = Array.from({length: 6}, (_, index) => {return { class:'video-third-height', cols:6 }}) 
                else if(window_is == 'extra-wide')
                    grid = Array.from({length: 6}, (_, index) => {return { class:'video-full-height', cols:2 }}) 
                else if(window_is == 'extra-narrow')
                    grid = Array.from({length: 6}, (_, index) => {return { class:'video-sixth-height', cols:12 }}) 
                else                  
                    grid = Array.from({length: 6}, (_, index) => {return { class:'video-half-height', cols:4 }})
            } 
            
            else if(count == 7) {
                if(['narrow', 'extra-narrow'].includes(window_is)) {
                    grid = Array.from({length: 6}, (_, index) => {return { class:'video-fifth-height', cols:6 }})
                    grid[6] = { class:'video-third-height', cols:12 }
                } else if(['wide', 'extra-wide'].includes(window_is)) {
                    grid = Array.from({length: 3}, (_, index) => {return { class:'video-half-height', cols:4 }})
                    grid[3] = { class:'video-half-height', cols:3 }
                    grid[4] = { class:'video-half-height', cols:3 }
                    grid[5] = { class:'video-half-height', cols:3 }
                    grid[6] = { class:'video-half-height', cols:3 }
                } else {
                    grid = Array.from({length: 4}, (_, index) => {return { class:'video-third-height', cols:6 }})
                    grid[4] = { class:'video-third-height', cols:4 }
                    grid[5] = { class:'video-third-height', cols:4 }
                    grid[6] = { class:'video-third-height', cols:4 }
                }
            }

            else if(count == 8) {
                if(['narrow', 'extra-narrow'].includes(window_is)) {
                    grid = Array.from({length: 8}, (_, index) => {return { class:'video-fourth-height', cols:6 }})
                } else if(['wide', 'extra-wide'].includes(window_is)) {
                    grid = Array.from({length: 8}, (_, index) => {return { class:'video-half-height', cols:3 }})
                } else {
                    grid = Array.from({length: 6}, (_, index) => {return { class:'video-third-small-height', cols:4 }})
                    grid[6] = { class:'video-third-large-height', cols:6 }
                    grid[7] = { class:'video-third-large-height', cols:6 }
                }
            }

            else if(count == 9){
                if(['narrow', 'extra-narrow'].includes(window_is)) {
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fifth-height', cols:6 }})
                } else if(['wide', 'extra-wide'].includes(window_is)) {
                    grid = Array.from({length: 4}, (_, index) => {return { class:'video-half-height', cols:3 }})
                    grid[4] = { class:'video-half-height', cols:2 }
                    grid[5] = { class:'video-half-height', cols:2 }
                    grid[6] = { class:'video-half-height', cols:2 }
                    grid[7] = { class:'video-half-height', cols:2 }
                    grid[8] = { class:'video-half-height', cols:4 }
                } else {
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:4 }})
                }
            }

            else if(count > 9 && count <=12 ) {
                if(['extra-narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-sixth-height', cols:6 }})
                else if(['wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:3 }})
                else if(['extra-wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-half-height', cols:2 }})
                else
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:4 }})
            }

            else if(count >= 13 && count <= 16) {

                if(['extra-narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-eighth-height', cols:6 }})
                else if(['narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-sixth-height', cols:4 }})
                else if(['wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:2 }})
                else if(['extra-wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:2 }})
                else
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:3 }})
            }

            else if(count >= 17 && count <= 24) {
                if(['extra-narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-eighth-height', cols:6 }})
                else if(['narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-eighth-height', cols:4 }})
                else if(['wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:2 }})
                else if(['extra-wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:1 }})
                else
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fourth-height', cols:2 }})
            }

            else if(count >= 25) {
                if(['extra-narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-eighth-height', cols:6 }})
                else if(['narrow'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-eighth-height', cols:3 }})
                else if(['portrait'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-sixth-height', cols:2 }})
                else if(['wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-fifth-height', cols:1 }})
                else if(['extra-wide'].includes(window_is))
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-third-height', cols:1 }})
                else
                    grid = Array.from({length: count}, (_, index) => {return { class:'video-sixth-height', cols:2 }})
            }

            this.grid = grid
            return
        },
        handleSnackbarClick: function(click) {
            if(click == 'chat')
                this.meeting.participants_chat_switch = 'chat'
        },
        logSessionId: function() {
            // this will help with tracking usage and sending notifications to HL when recordings are available

            if(this.session_is_logged)
                return
            this.session_is_logged = true
            console.log("Log session id now >>", this.meeting.session_id)
            
            //location and contact ids, if present
            const { l, c } = this.$route.query

            console.log("route query:", this.$route.query.l, this.$route.query.c)

            // crete the log record, if we have the location_id (l) and contact_id (c), they'll be used to send the recording info back to HL
            this.app.post('meeting/log_session', {
                session_id: this.meeting.session_id,
                location_id: l,
                contact_id: c,
                email_address: this.email_address,
                room_id: this.app.room.ID,
            })
        },
        saveLobbyName() {
            this.app.showSuccess('Name saved')
        }
    },
    watch: {
        // 'meeting.blur_on': function(newV) {
        //     console.log("meeting blur_on", newV)
        //     this.meeting.toggle_blur = newV
        // },
        // 'user.userdata': {
        //     handler: function(newV) {
        //         console.log("watch userdata", newV)
        //     },
        //     deep: true
        // },
        'name': function(newV, oldV) {
            window.localStorage.setItem('meeting_display_name', newV)
            if(this.isLobby)
                this.updateLobbyGuestName()
        },
        'meeting.room_started': function(newV, oldV) {
            console.log("room_started", newV, oldV)
        },
        'meeting.is_connected': function(newV, oldV) {
            // console.log("is connected:", newV, oldV, this.meeting?.local_peer?.roleName, ['guest', 'waiting-room'].includes(this.meeting?.local_peer?.roleName))
            if(newV && !oldV && ['guest', 'waiting-room'].includes(this.meeting?.local_peer?.roleName)) {
                //if email address is provided, send request to trigger webhooks
                if(this.app.room.settings.show_email_field && this.email_address) {
                    this.app.post('meeting/webhook', {
                        type: 'email_address_submitted',
                        room_id: this.app.room.ID,
                        email_address: this.email_address,
                    })
                }
            }
            if(newV && this.peers.length > 0 
                && !this.meeting.recording_state?.browser?.running
                && this.app.room.settings.autorecord
            ) this.meeting.toggle_auto_record = true

            if(newV && this.meeting?.local_peer?.roleName == 'host' && this.meeting.session_id)
                this.logSessionId()
        },
        'meeting.session_id': function(newV, oldV) {
            if(newV && this.meeting?.local_peer?.roleName == 'host') {
                this.logSessionId()
            }
        },
        peers: function(newV) {
            // handle waiting room

            // setting is host-approval, then the host will manually admin
            if(this.app.room.settings.waiting_room == 'host-approval')
                return

            // none or wait-for-host
            if(this.meeting?.permissions?.changeRole && this.meeting.local_peer.roleName == 'host') {
                this.peers.forEach(peer => {
                    if(peer.roleName == 'waiting-room')
                        this.meeting.hmsActions.changeRole(peer.id, 'guest', true);
                }) 
            }
        },
        selected_camera: function(newV) {
            if(newV) {
                hmsActions.setVideoSettings({ deviceId: newV })
            }
        },
        selected_microphone: function(newV) {
            if(newV) {
                hmsActions.setAudioSettings({ deviceId: newV })
            }
        },
        selected_devices: async function(newV, oldV) {
            if(['record', 'record-guest'].includes(this.$route.params.role)) {
                return this.join()
                // return
            }

            if(this.$route.query.skip_preview == '1'){
                return this.join()
            }

            if(this.selected_devices.videoInputDeviceId)
                if(!['record', 'record-guest'].includes(this.$route.params.role))
                    this.inPreview(true)
                else
                    return this.join()
        },
        'meeting.participants_chat_switch': function(newV) {
            if(newV == null)
                return
        },
        'meeting.toggle_blur': function(newV) {
            // console.log("toggle_blur", newV)
            this.meeting.toggle_blur = false
            if(newV)
                this.blurOn()
            else
                this.blurOff()
        },
        local_peer: function(newV, oldV) {
        },
        'meeting.local_video_enabled': function(newV) {
            if(newV) {
                hmsActions.setLocalVideoEnabled(true)
                this.$nextTick(() => {
                    let is_in_preview = hmsStore.getState(selectIsInPreview)
                    let ref = is_in_preview ? 'preview_video' : this.meeting.local_peer.id
                    if(this.meeting?.local_peer?.videoTrack)
                        hmsActions.attachVideo(this.meeting.local_peer.videoTrack, this.$refs[ref])
                })
            } else if(!newV) {
                hmsActions.setLocalVideoEnabled(false)
            }
        },
        video_peers: {
            handler() {
                this.$nextTick(() => this.renderPeers())
            },
            deep: true
        },
        'meeting.toggle_screenshare': function(newV, oldV) {
            if(oldV == undefined)
                return
            this.toggleScreen()
        },
        'meeting.show_settings': function(newV) {
            if(newV) {
                this.app.loadRooms()
            }
        },
        'app.room.ID': async function(newV) {
            this.app.setUpTheme(this.$vuetify)

            if(!this.meeting.is_connected || !this.meeting.hmsStore)
                return

            //send meeting notification to update current participants
            const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
            const newMetadata = { ...metadata, room: this.app.room }
            await this.meeting.hmsActions.changeMetadata(newMetadata)
        },
        'selected_room': function(newV) {
            console.log("selected_room", newV)
        },
        'meeting.livestream_state': function(newV) {
            console.log('watch meeting.livestream_state', newV)

            //turn off loading indicators
            if(newV.running)
                this.meeting.rtmp_starting = false
            else
                this.meeting.rtmp_stopping = false

            //TODO: need to refactor this to separate out more clearly RTMP vs Livestream
            if(this.meeting.livestream_state?.running && this.meeting.livestream_state.variants) {
                const hlsUrl = this.meeting.livestream_state.variants[0]?.url
                // const video = document.getElementById('video');
                const video = this.$refs.livestream_video
                const browserHasNativeHLSSupport = video.canPlayType('application/vnd.apple.mpegurl');
                if (Hls.isSupported()) {
                    let hls = new Hls();
                    hls.loadSource(hlsUrl);
                    hls.attachMedia(video);
                    this.$nextTick(() => {
                        // hmsActions.attachVideo(this.aux_track, this.$refs.screenshare_video)
                        hls.attachMedia(video);
                    })
                }
                // hls.js is not supported on iOS Safari, but as the browser has native support for playing HLS,
                // we can use the video element directly.
                else if (browserHasNativeHLSSupport) {
                    video.src = hlsUrl;
                }
            }
        }

    }

}


</script>

<style scoped>
.mirror {
    transform: scaleX(-1);
}
#leave_btn {
    bottom: 15px;
}
.video-full-height {
    height: calc(100vh - 136px);
    max-height: calc(100vh - 136px);
}
.video-two-thirds-height {
    height: calc(67vh - 136px);
    max-height: calc(100vh - 136px);
}
.video-half-height {
    height: calc(50vh - 78px);
    max-height: calc(50vh - 78px);
}
.video-fourth-height {
    height: calc(25vh - 38px);
}
.video-third-small-height {
    height: calc(30vh - 46px);
}
.video-third-large-height {
    height: calc(39vh - 46px);
}
.video-third-height {
    height: calc(33vh - 46px);
}
.video-quarter-height {
    height: calc(25vh - 38px);
}
.video-fifth-height {
    height: calc(20vh - 30px);
}
.video-sixth-height {
    height: calc(16vh - 17px);
}
.video-five-sixths-height {
    height: calc(16vh - 155px);
}
.video-eighth-height {
    height: calc(12vh - 12px);
}
.translate-half {
    transform:translateY(20vh);
}
.translate-third {
    transform:translateY(15vh);
}
.translate-fourth {
    transform:translateY(10vh);
}
.hello_name {
    text-decoration: double !important;
    border: 1px dotted;
    padding: 0 8px;
    border-radius: 10px; 
}
</style>
